import { createClient } from '@supabase/supabase-js';

// Supabase URL ve Anon Key - Environment variables'dan al
// React (create-react-app) için REACT_APP_ prefix kullanılır
const supabaseUrl = process.env.REACT_APP_SUPABASE_URL;
const supabaseAnonKey = process.env.REACT_APP_SUPABASE_ANON_KEY;

if (!supabaseUrl || !supabaseAnonKey) {
    console.warn('⚠️ Supabase credentials eksik! Lütfen .env dosyasına REACT_APP_SUPABASE_URL ve REACT_APP_SUPABASE_ANON_KEY ekleyin.');
}

// Görev 1: Supabase client'ı doğru init et
// - persistSession: true → Oturum localStorage'da saklanır (F5 ile uçmaz)
// - autoRefreshToken: true → Token otomatik yenilenir
// - detectSessionInUrl: true → URL'den session yakalar (email verification, recovery)
export const supabase = supabaseUrl && supabaseAnonKey
    ? createClient(supabaseUrl, supabaseAnonKey, {
        auth: {
            persistSession: true,
            autoRefreshToken: true,
            detectSessionInUrl: true,
            storage: typeof window !== 'undefined' ? window.localStorage : undefined,
            // Flow type: PKCE (daha güvenli)
            flowType: 'pkce'
        }
    })
    : null;

